var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue";
var _hoisted_1 = { class: "atomizer-box" };
var _hoisted_2 = { class: "atomizer-box__cover" };
var _hoisted_3 = { class: "atomizer-box__main" };
var _hoisted_4 = { class: "atomizer-box__block" };
var _hoisted_5 = { class: "atomizer-box__block" };
var _hoisted_6 = {
    key: 0,
    class: "atomizer-price"
};
var _hoisted_7 = { class: "atomizer-price__qty" };
var _hoisted_8 = { class: "atomizer-price__value" };
var _hoisted_9 = { class: "atomizer-price__button" };
import { computed, ref } from "vue";
import ModalDialog from "../../../../components/modal/ModalDialog.vue";
import Picture from "../../../../components/Picture.vue";
import QuantityBox from "../products/QuantityBox.vue";
import { handleAddToCartButtonClick } from "../../../../components/product/add_to_cart";
import CartEventBus from "../../CartEventBus";
import FilterSelector from "../../../product/components/FilterSelector.vue";
import Price from "../../../../components/Price.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'AtomizerModal',
    props: {
        atomizers: { type: Array, required: true },
    },
    setup: function (__props, _a) {
        var __expose = _a.expose;
        var props = __props;
        var modal = ref();
        var selectedVolume = ref();
        var selectedColor = ref();
        var quantity = ref(1);
        // 1. Уникальные объемы (для первого фильтра)
        var volumeFilterItems = computed(function () {
            return __spreadArray([], __read(new Set(props.atomizers.map(function (a) { return a.volume; }))), false).sort(function (a, b) { return a - b; })
                .map(function (v) { return ({ id: v, name: "".concat(v, " \u043C\u043B") }); });
        });
        // 2. Уникальные цвета для выбранного объема
        var colorFilterItems = computed(function () {
            if (!selectedVolume.value) {
                return [];
            }
            var available = props.atomizers
                .filter(function (a) { var _a; return a.volume === ((_a = selectedVolume.value) === null || _a === void 0 ? void 0 : _a.id); })
                .map(function (a) { return ({
                id: a.color,
                name: a.color,
                color_code: a.color_code,
            }); });
            return available.sort(function (a, b) { return a.name.localeCompare(b.name); });
        });
        // 3. Итоговый атомайзер ищем по комбинации Объем + Цвет
        var selectedAtomizer = computed(function () {
            return props.atomizers.find(function (a) {
                var _a, _b;
                return a.volume === ((_a = selectedVolume.value) === null || _a === void 0 ? void 0 : _a.id) &&
                    a.color === ((_b = selectedColor.value) === null || _b === void 0 ? void 0 : _b.id);
            });
        });
        var sum = computed(function () {
            return selectedAtomizer.value ? selectedAtomizer.value.price * quantity.value : 0;
        });
        function show() {
            var _a;
            (_a = modal.value) === null || _a === void 0 ? void 0 : _a.open();
        }
        function close() {
            var _a;
            (_a = modal.value) === null || _a === void 0 ? void 0 : _a.close();
        }
        __expose({ show: show });
        function addToCart() {
            return __awaiter(this, void 0, void 0, function () {
                var id;
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            id = (_a = selectedAtomizer.value) === null || _a === void 0 ? void 0 : _a.id;
                            if (!id) {
                                return [2 /*return*/];
                            }
                            return [4 /*yield*/, handleAddToCartButtonClick({ id: id, cnt: quantity.value, silent: true })];
                        case 1:
                            _b.sent();
                            CartEventBus.emit('cart:refresh');
                            close();
                            return [2 /*return*/];
                    }
                });
            });
        }
        return function (_ctx, _cache) {
            return (_openBlock(), _createBlock(ModalDialog, {
                id: "modal-atomizer",
                title: "Выбор атомайзера",
                size: "lg",
                ref_key: "modal",
                ref: modal
            }, {
                main: _withCtx(function () { return [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                            (selectedAtomizer.value)
                                ? (_openBlock(), _createBlock(Picture, {
                                    picture: selectedAtomizer.value.image,
                                    key: selectedAtomizer.value.id,
                                    aspect: false,
                                    lazy: false,
                                    width: 200,
                                    height: 200
                                }, null, 8 /* PROPS */, ["picture"]))
                                : _createCommentVNode("v-if", true)
                        ]),
                        _cache[4] || (_cache[4] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _createVNode(FilterSelector, {
                                    title: "Объём",
                                    items: volumeFilterItems.value,
                                    name: "atomizer_volume",
                                    modelValue: selectedVolume.value,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return ((selectedVolume).value = $event); })
                                }, null, 8 /* PROPS */, ["items", "modelValue"])
                            ]),
                            _cache[3] || (_cache[3] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_5, [
                                _createVNode(FilterSelector, {
                                    title: "Цвет",
                                    items: colorFilterItems.value,
                                    name: "atomizer_color",
                                    modelValue: selectedColor.value,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) { return ((selectedColor).value = $event); })
                                }, null, 8 /* PROPS */, ["items", "modelValue"])
                            ])
                        ])
                    ])
                ]; }),
                bottom: _withCtx(function () { return [
                    (selectedAtomizer.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createElementVNode("div", _hoisted_7, [
                                _createVNode(QuantityBox, {
                                    modelValue: quantity.value,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) { return ((quantity).value = $event); })
                                }, null, 8 /* PROPS */, ["modelValue"])
                            ]),
                            _cache[6] || (_cache[6] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_8, [
                                _createVNode(Price, { amount: sum.value }, null, 8 /* PROPS */, ["amount"])
                            ]),
                            _cache[7] || (_cache[7] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("button", {
                                    onClick: _withModifiers(addToCart, ["prevent"]),
                                    class: "btn btn--1 btn--m btn--black"
                                }, __spreadArray([], __read((_cache[5] || (_cache[5] = [
                                    _createElementVNode("span", { class: "btn__label" }, "Добавить", -1 /* CACHED */)
                                ]))), false))
                            ])
                        ]))
                        : _createCommentVNode("v-if", true)
                ]; }),
                _: 1 /* STABLE */
            }, 512 /* NEED_PATCH */));
        };
    }
});
